<div class="company-initialization-form" tiimeFormColumn>
  <span tiimeFormTitle>Plan de labels</span>
  <mat-radio-group class="label-mode-radio-group" color="primary" formControlName="labelMode">
    <mat-radio-button color="primary" value="labelPlan">Choisir un plan de labels existant</mat-radio-button>
    @if (withFEC()) {
      <mat-radio-button color="primary" value="fecFile">Importer un fichier FEC</mat-radio-button>
    }
  </mat-radio-group>
  @if (parametersStepForm.labelMode.value === 'labelPlan') {
    <app-label-plan-select
      [ctrl]="parametersStepForm.controls.labelPlan"
      [labelsPlans]="labelsPlans()"
      label="Choisir un plan de labels"
    ></app-label-plan-select>
  }
  @if (parametersStepForm.labelMode.value === 'fecFile') {
    <tiime-input-container
      tiimeFormInputContainer
      contentId="fecFile"
      class="fec-file-input"
      label="Importer un fichier FEC"
      (click)="file.click()"
    >
      <input id="fecFile" placeholder="Importer un fichier FEC" [value]="parametersStepForm.fecFile?.value?.name" />
      <div class="flex suffix">
        <button
          tiime-button
          icon
          color="primary"
          (click)="resetFecFile()"
          [hidden]="!parametersStepForm.fecFile?.value?.name"
        >
          <mat-icon fontSet="fontastic" fontIcon="icon-ic-remove" inline="true"></mat-icon>
        </button>
        @if (!parametersStepForm.fecFile?.value?.name) {
          <button tiime-button icon color="primary">
            <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-download-24"></mat-icon>
          </button>
        }
        <mat-icon
          tiimeTooltip
          [tooltipContent]="fecTooltipTemplate"
          class="initialization-content-option-info"
          inline="true"
          fontSet="fontastic"
          fontIcon="icon-ic-info"
        ></mat-icon>
        <ng-template #fecTooltipTemplate>
          Le fichier FEC (provisoire ou définitif) est utilisé pour personnaliser les paramétrages de votre dossier. Si
          vous n’avez aucun FEC, vous pouvez également proposer un plan comptable.
          <br />
          <br />
          {{ acceptedTypesLabel }}
        </ng-template>
      </div>
      <input
        hidden
        #file
        id="file"
        type="file"
        [accept]="acceptedTypes"
        (change)="uploadFEC(file.files)"
        (abort)="$event.stopPropagation()"
        (cancel)="$event.stopPropagation()"
      />
    </tiime-input-container>
  }
  @if (parametersStepForm.touched && parametersStepForm.invalid) {
    <tiime-alert warn>
      {{ errorMessage() }}
    </tiime-alert>
  }
  <div tiimeFormVerticalSeparator></div>
  <span tiimeFormTitle>Plan de catégories (facultatif)</span>
  <app-label-category-plan-select
    emptyOption="Aucun"
    [ctrl]="parametersStepForm.controls.categorySetupPlan"
    [labelCategoryPlans]="labelCategoryPlans()"
    [createOption]="false"
    label="Choisir un plan de catégories"
  ></app-label-category-plan-select>
</div>
<div class="company-initialization-help" tiimeFormColumn>
  <div class="company-initialization-help-title" tiimeFormTitle>
    <mat-icon>help</mat-icon>
    Aide au paramétrage
  </div>
  <span tiimeFormTitle>Plan de labels existant</span>
  <span>Listes de labels paramétrés par les administrateurs de votre cabinet.</span>
  @if (withFEC()) {
    <span tiimeFormTitle>Fichier FEC</span>
    <span>Les labels et leur schéma d'écriture seront extrait de votre fichier FEC.</span>
  }
  <div tiimeFormTitle class="company-initialization-help-catagory-plan-title">
    <span>Plan de catégories</span>
    <button
      tiime-button
      small
      strocked
      color="primary"
      icon
      tiimeTooltip="Voir le paramétrage des plans de catégories"
      (click)="openLabelCategoryPlanSetupDialog()"
    >
      <mat-icon>settings</mat-icon>
    </button>
  </div>
  <ul>
    <li>Catégories de labels paramétrés dans Tiime.</li>
    <li>Peuvent être crées par l'entrepreneur, vos collaborateurs ou les moteurs de Tiime.</li>
  </ul>
</div>
